/* eslint-disable */
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { ClientApi } from '../services';
import swasnaClientApiErrorHandler from '../services/errorHandler';

const store = configureStore({
  reducer: {
    [ClientApi.reducerPath]: ClientApi.reducer,
    [ClientApi.reducerPath]: ClientApi.reducer,
    ...rootReducer,
  },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(ClientApi.middleware)
    .concat(swasnaClientApiErrorHandler),
  
});

export default store;
 